import api from '~services/axios';

export default {
  apiGetCrmRole: params => api.get('/api/crmAuthority/crmRole', { params }),

  apiGetCrmAuthorityMenu: params => api.get('/api/crmAuthority/crmMenu', { params }),

  apiUpdateOperate: params => api.post('/api/crmAuthority/save/operate', params),

  apiUpdateData: params => api.post('/api/crmAuthority/save/data', params),

  // 获取用户权限信息
  apiGetAuthority: params => api.get('/api/common/auth', { params }),
  // 获取用户团队列表
  apiGetTeamList: params => api.post('/api/team/query/dropdown', params),
  // 获取用户基础信息
  apiGetUserInfo: params => api.post('/api/common/crmAuth', { params }),
};
